export default [{
  text: '',
  items: [
    { icon: 'mdi-view-dashboard-outline', key: 'menu.dashboard', text: 'Dashboard', link: '/dashboard'  },
    { icon: 'mdi-badge-account', key: 'menu.blank', text: 'Enumerators', link: '/enumerators' },
    /*{ icon: 'mdi-account-question', key: 'menu.blank', text: 'Farmers Verifier', link: '/farmersVerifier' },
    { icon: 'mdi-sprout', key: 'menu.blank', text: 'Farmers Registration', link: '/farmersRegistration' },
    { icon: 'mdi-chart-bell-curve', key: 'menu.blank', text: 'Summaries', link: '/summary' },
    { icon: 'mdi-bell', key: 'menu.blank', text: 'Picture', link: '/picture' } ,*/
    { icon: 'mdi-logout', key: 'menu.blank', text: 'Logout', link: '/logout' } 
  ]
}]